import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
// Import required modules
import { Pagination, Autoplay, EffectCoverflow } from 'swiper/modules';

interface SwiperGalleryProps {
  images: {
    src: string;
    alt: string;
  }[];
  onImageClick: (image: {src: string, alt: string}, index: number) => void;
}

const SwiperGallery: React.FC<SwiperGalleryProps> = ({ images, onImageClick }) => {
  return (
    <div className="gallery-swiper mt-8">
      <Swiper
        modules={[Pagination, Autoplay, EffectCoverflow]}
        spaceBetween={20}
        slidesPerView={1.3}
        centeredSlides={true}
        pagination={{ 
          clickable: true,
          el: '.swiper-pagination-gallery',
          bulletActiveClass: 'swiper-pagination-bullet-active'
        }}
        loop={true}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        }}
        speed={800}
        effect="coverflow"
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 1.5,
          slideShadows: true
        }}
      >
        {images.map((image, index) => (
          <SwiperSlide key={`slide-${index}`}>
            <div 
              className="gallery-item"
              onClick={() => onImageClick(image, index)}
            >
              <img 
                src={image.src} 
                alt={image.alt} 
                className="gallery-image"
                loading="lazy" 
              />
              <div className="gallery-item-overlay">
                <div className="gallery-item-icon">
                  <i className="fas fa-search-plus"></i>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="swiper-pagination-gallery" style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        marginTop: '20px' 
      }}></div>
      
      <style dangerouslySetInnerHTML={{__html: `
        .gallery-item {
          position: relative;
          overflow: hidden;
          width: 100%;
          height: 100%;
          aspect-ratio: 1;
          border-radius: 12px;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
          transition: transform 0.3s ease;
        }
        
        .gallery-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }
        
        .gallery-item-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.3);
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        
        .gallery-item:hover .gallery-item-overlay {
          opacity: 1;
        }
        
        .gallery-item-icon {
          color: white;
          font-size: 2rem;
          background-color: rgba(255, 200, 0, 0.8);
          border-radius: 50%;
          width: 60px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          transform: scale(0.8);
          transition: transform 0.3s ease;
        }
        
        .gallery-item:hover .gallery-item-icon {
          transform: scale(1);
        }
        
        .swiper-pagination-bullet {
          width: 10px;
          height: 10px;
          background-color: #ccc;
          opacity: 0.7;
          margin: 0 5px;
          transition: all 0.3s ease;
        }
        
        .swiper-pagination-bullet-active {
          background-color: #ffc800 !important;
          transform: scale(1.3);
          opacity: 1;
        }
        
        .swiper-slide-active .gallery-item {
          transform: scale(1.05);
        }
      `}} />
    </div>
  );
};

export default SwiperGallery; 